var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.25H20M2.5 11.25V7C2.5 6.58579 2.83579 6.25 3.25 6.25H26.75C27.1642 6.25 27.5 6.58579 27.5 7V11.25V23C27.5 23.4142 27.1642 23.75 26.75 23.75H3.25C2.83579 23.75 2.5 23.4142 2.5 23V11.25Z",
    stroke: "#434289",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15H19.5C19.0858 15 18.75 15.3358 18.75 15.75V19.25C18.75 19.6642 19.0858 20 19.5 20H23C23.4142 20 23.75 19.6642 23.75 19.25V15.75C23.75 15.3358 23.4142 15 23 15Z",
    fill: "#434289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.a3589ac4f55c18308f2d540c5c82d8a5.svg";
export { ForwardRef as ReactComponent };